import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "goto"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_van_empty = _resolveComponent("van-empty");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [$data.showEmptyProgressOrder ? (_openBlock(), _createBlock(_component_van_empty, {
    key: 0
  }, {
    description: _withCtx(() => [_createTextVNode(" 没有正在进行的行程 ")]),
    _: 1
  })) : _createCommentVNode("", true)]);
}